import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadReportConfirmationPaymentPDF = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: {
        width: "15%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Produtor",
    },
    {
      style: {
        width: "10%",
        textAlign: "left",
      },
      title: "Operadora",
    },
    {
      style: {
        width: "10%",
        textAlign: "center",
      },
      title: "Proposta",
    },
    {
      style: {
        width: "6%",
        textAlign: "center",
      },
      title: "N parc.",
    },
    {
      style: {
        width: "9%",
        textAlign: "right",
      },
      title: "Data pagto",
    },
    {
      style: {
        width: "9%",
        textAlign: "right",
      },
      title: "Data venc.",
    },
    {
      style: {
        width: "5%",
        textAlign: "center",
      },
      title: "Vidas",
    },
    {
      style: {
        width: "9%",
        textAlign: "right",
        paddingLeft: "6px",
      },
      title: "V. mensal.",
    },
    {
      style: {
        width: "10%",
        textAlign: "right",
      },
      title: "% Comissão",
    },
    {
      style: {
        width: "17%",
        textAlign: "right",
        paddingRight: "8px",
      },
      title: "V. comissão",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
